import { render } from "./DatasetDetail.vue?vue&type=template&id=22c59ba6&scoped=true"
import script from "./DatasetDetail.vue?vue&type=script&lang=js"
export * from "./DatasetDetail.vue?vue&type=script&lang=js"

import "./DatasetDetail.vue?vue&type=style&index=0&id=22c59ba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c59ba6"]])

export default __exports__